/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Branch } from './Branch';
import {
    BranchFromJSON,
    BranchFromJSONTyped,
    BranchToJSON,
    BranchToJSONTyped,
} from './Branch';

/**
 * 
 * @export
 * @interface BranchWithNetSalesAndQuantity
 */
export interface BranchWithNetSalesAndQuantity {
    /**
     * 
     * @type {Branch}
     * @memberof BranchWithNetSalesAndQuantity
     */
    branch: Branch;
    /**
     * 
     * @type {number}
     * @memberof BranchWithNetSalesAndQuantity
     */
    net_sales: number;
    /**
     * 
     * @type {number}
     * @memberof BranchWithNetSalesAndQuantity
     */
    quantity: number;
}

/**
 * Check if a given object implements the BranchWithNetSalesAndQuantity interface.
 */
export function instanceOfBranchWithNetSalesAndQuantity(value: object): value is BranchWithNetSalesAndQuantity {
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('net_sales' in value) || value['net_sales'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function BranchWithNetSalesAndQuantityFromJSON(json: any): BranchWithNetSalesAndQuantity {
    return BranchWithNetSalesAndQuantityFromJSONTyped(json, false);
}

export function BranchWithNetSalesAndQuantityFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchWithNetSalesAndQuantity {
    if (json == null) {
        return json;
    }
    return {
        
        'branch': BranchFromJSON(json['branch']),
        'net_sales': json['net_sales'],
        'quantity': json['quantity'],
    };
}

export function BranchWithNetSalesAndQuantityToJSON(json: any): BranchWithNetSalesAndQuantity {
    return BranchWithNetSalesAndQuantityToJSONTyped(json, false);
}

export function BranchWithNetSalesAndQuantityToJSONTyped(value?: BranchWithNetSalesAndQuantity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branch': BranchToJSON(value['branch']),
        'net_sales': value['net_sales'],
        'quantity': value['quantity'],
    };
}

